var jmc = jmc || {}

// ################################################################################################################
// API
// ################################################################################################################
jmc.cart = {}
jmc.cart.queue = [] // { msg: String, data: Object, onSuccess: Function?, onError: Function? }
jmc.cart.wasRunning = false

jmc.cart.update = function(data) {
  var api = {
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
  }

  return $.ajax(api)
}

jmc.cart.change = function(data) {
  var api = {
    type: 'POST',
    url: '/cart/change.js',
    data: data,
    dataType: 'json',
  }

  return $.ajax(api)
}

jmc.cart.add = function(data) {
  var api = {
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
  }

  return $.ajax(api)
}

jmc.cart.queueUp = function(payload) {
  if (payload) {
    jmc.cart.queue.push(payload)
  }
}

jmc.cart.moveAlong = function() {
  if (jmc.cart.queue.length) {
    jmc.cart.wasRunning = true
    var req = jmc.cart.queue.shift()
    jmc.cart.callAPI(req.action, req.data, req.onSuccess, req.onError)
  } else if (jmc.cart.wasRunning) {
    window.location.href = '/cart'
  }
}

jmc.cart.callAPI = function(msg, data, _onSuccess, _onError) {
  // Normalize callbacks
  var onSuccess = typeof _onSuccess == 'function' ? _onSuccess : console.log

  var onError = typeof _onError == 'function' ? _onError : console.error

  switch (msg) {
    case 'UPDATE':
      return jmc.cart
        .update(data)
        .then(onSuccess, onError)
        .then(jmc.cart.moveAlong)

    case 'ADD':
      return jmc.cart
        .add(data)
        .then(onSuccess, onError)
        .then(jmc.cart.moveAlong)

    case 'CHANGE':
      return jmc.cart
        .change(data)
        .then(onSuccess, onError)
        .then(jmc.cart.moveAlong)

    default:
      return console.error('Action [', msg, '] not found')
  }
}

/*============================================================================
  OBSERVER - Purpose of this fn is to call 'jmc.cart.moveAlong' on initial load
==============================================================================*/
jmc.Observer = (function() {
  function BigBrother() {
    this.state = {
      watchList: {}, // { [NAMESPACE]: [Bool] }
    }
  }

  BigBrother.prototype.shouldMove = function(key) {
    return !this.state.watchList[key]
  }

  BigBrother.prototype.checkMove = function() {
    if (Object.keys(this.state.watchList).every(this.shouldMove, this)) {
      jmc.cart.moveAlong()
    }
  }

  BigBrother.prototype.observe = function(key) {
    this.state.watchList[key] = true
  }

  BigBrother.prototype.unobserve = function(key) {
    this.state.watchList[key] = false
    this.checkMove()
  }

  return BigBrother
})()

// Samples / Promotions
jmc.giftObserver = (function() {
  function init() {
    jmc.bigBrother = new jmc.Observer()
    // We need to observe first, then init
    var cart = JSON.parse(
      (document.getElementById('CartJson') || {}).innerHTML
    )
    var promotions = ['samples'].reduce(
      function(a, promotion) {
        if (theme[promotion].isEnabled) {
          a.observeFns.push(
            jmc.bigBrother.observe.bind(jmc.bigBrother, promotion)
          )
          a.initFns.push(jmc[promotion].init.bind(null, theme[promotion], cart))
        }

        return a
      },
      { observeFns: [], initFns: [] }
    )

    Object.keys(promotions).forEach(function(key) {
      var fnList = promotions[key]
      fnList.forEach(function(fn) {
        fn()
      })
    })
  }

  return {
    init: init,
  }
})()

// ################################################################################################################
// SAMPLES
// ################################################################################################################
jmc.samples = (function(s,c) {

  var settings = {
    isEnabled: false,
    max: 3,
    samples: [], // Product object
    omit: [], // Variant ID
  }

  var state = {
    hasGift: false,
    doesQualify: false,
    giftQty: 0,
    activeGift: [], // Variant ID
  }

  function setState(s, cartObject) {
    cartObject.items.forEach(function(item) {
      if(item.product_type == 'Sample') {
        state.hasGift = true
        state.activeGift.push(item.variant_id)
        state.giftQty += item.quantity
      } else if (item.requires_shipping && item.price > 0) {
        state.doesQualify = true
      }
    })
  }

  function addSwapRemove(variantId) {
    var ret = []
    var hasSelected = state.activeGift.some(function(id) {
      return id == variantId
    })

    // Remove
    if (hasSelected) {
      var queue = {}
      queue.action = 'UPDATE'
      queue.data = {}
      queue.data.updates = {}
      queue.data.updates[JSON.stringify(variantId)] = 0
      ret.push(queue)
    } else {
      // Add selected gift if it is different from initial
      ret.push({
        action: 'ADD',
        data: { quantity: 1, id: variantId },
      })

      if (state.giftQty >= settings.max) {
        // Remove last gift
        var queue = {}
        queue.action = 'UPDATE'
        queue.data = {}
        queue.data.updates = {}
        queue.data.updates[
          JSON.stringify(state.activeGift[state.activeGift.length - 1])
        ] = 0
        ret.push(queue)
      }
      
    }

    return ret
  }

  // Check validity of cart
  // Return array
  function getInitialQueues() {
    var ret = []
    // If there are more than X sample or customer no longer qualifies for samples, remove them all
    if (!state.doesQualify) {
      var updates = state.activeGift.reduce(function(a, c) {
        console.log(settings.max)
        a[c] = 0
        return a
      }, {})

      if (Object.keys(updates).length) {
        ret.push({
          action: 'UPDATE',
          data: { updates: updates },
        })
      }
    }

    // If customer's gift qty is more than 1, reduce
    if (
      state.doesQualify &&
      state.giftQty > 1 &&
      state.activeGift.length == 1
    ) {
      ret.push({
        action: 'CHANGE',
        data: {
          quantity: 1,
          id: state.activeGift[0],
        },
      })
    }

    return ret
  }

  function checkCart() {
    var queues = getInitialQueues()
    queues.forEach(function(queue) {
      jmc.cart.queueUp(queue)
    })
  }
  
  function checkExtraSamples(){
  	var ret = []
    if (state.activeGift.length > settings.max) {
        // Remove extra
        var queue = {}
        queue.action = 'UPDATE'
        queue.data = {}
        queue.data.updates = {}
        queue.data.updates[
          JSON.stringify(state.activeGift[settings.max])
        ] = 0
        ret.push(queue)
      }
    
    var payload = ret
    payload.forEach(function(queue) {
      jmc.cart.queueUp(queue)
    })
  }

  function bindUIEvents() {
    // Big brother should not care about user events
    $('.js-sample').on('click', function(e) {
      e.preventDefault()
      if(1 == 1){
        
      }
      else {
        var variantId = parseInt($(this).data('variant-id'), 10)
        var payload = addSwapRemove(variantId);
        payload.forEach(function(queue) {
          jmc.cart.queueUp(queue)
        })
  
        jmc.cart.moveAlong()
      }
    })
  }

  function initSamples(s, cartObject) {
    setState(s, cartObject)
    checkExtraSamples()
    bindUIEvents()
    checkCart()
    jmc.bigBrother.unobserve('samples')
  }

  function init(s, cartObject) {
    cart = cartObject
    settings = $.extend(settings, s)

    if (settings.isEnabled) {
      initSamples(s, cartObject)
    }
  }

  return {
    init: init,
  }
})()

// ################################################################################################################
// INIT
// ################################################################################################################
jmc.init = function() {
  jmc.giftObserver.init()
}

//$(jmc.init)